import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

import Icon           from 'app/components/common/icon';
import Link           from 'app/components/common/link';
import NonprofitCard  from 'app/components/nonprofits/nonprofit-card';
import NonprofitsDuck from 'app/ducks/nonprofits';
import utils          from 'app/helpers/utils';
import paths          from 'app/paths';

const commonCardProps = {
  noInteraction: true,
  imgWidth: 320,
  responsive: false,
};

const shownCount = 34;

class FfaHero extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      ids: null,
      swap: {},
      lastUsedHi: shownCount - 1,
    };

    this.intervalSwap = null;
  }

  componentDidMount() {
    this.props.load();
    this.intervalSwap = setInterval(this.swap.bind(this), 3000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalSwap);
  }

  getIds(state=this.state) {
    return state.ids || this.props.ids;
  }

  // the 6 next hidden indicies - used to preload images
  getNext6hi(state=this.state) {
    let {lastUsedHi} = state;
    const ids = this.getIds(state) || [];
    if (ids.length < shownCount) return [];
    const next = [];
    _.times(6, () => {
      lastUsedHi += 1;
      if (lastUsedHi >= ids.length) {
        lastUsedHi = shownCount;
      }
      next.push(lastUsedHi)
    });
    return next;
  }

  swap() {
    const totalCount = this.getIds()?.length || 0;
    if (totalCount < shownCount) return;

    this.setState((prevState) => {
      const prevIds = this.getIds(prevState);
      const newState = {swap: {}, ids: [...prevIds]};
      // calculate new shown and hidden swap indices - don't use the same ones from previous
      const prevShownIndices = Object.keys(prevState.swap).map(str => parseInt(str));
      const prevHiddenIndices = Object.values(prevState.swap);
      const newShownIndices = utils.randomN(0, shownCount-1, 3, prevShownIndices);
      const newHiddenIndices = this.getNext6hi(prevState);
      // build swap map
      newShownIndices.forEach((si, i) => {
        const hi = newHiddenIndices[i];
        newState.swap[si] = hi;
      });
      // calculate new ids array based on previous swap map
      if (Object.keys(prevState.swap).length) {
        const newIds = [...prevIds];
        Object.entries(prevState.swap).forEach(([siStr, hi]) => {
          const si = parseInt(siStr);
          const tmp = newState.ids[si];
          newState.ids[si] = newState.ids[hi];
          newState.ids[hi] = tmp;
        });
      }
      // update lastUsedHi
      newState.lastUsedHi = _.last(newHiddenIndices.slice(0, 3));
      return newState;
    });
  }

  renderBg() {
    const {swap} = this.state;
    const ids = this.getIds();
    if (!ids?.length) return null;

    const ids1 = ids.slice(0, 11);
    const ids2 = ids.slice(11, 23);
    const ids3 = ids.slice(23, 34);
    let idIndex = -1;

    return (
      <div className="ffa-hero-bg">
        <div className="ffa-hero-bg-fade" />
        {[ids1, ids2, ids3].map((rowIds, i) => {
          return (
            <div key={i} className="ffa-hero-bg-row">
              {rowIds.map((id, j) => {
                idIndex += 1;
                const swapIndex = swap[idIndex];
                const isSwapping = swapIndex != null;
                const outClass = isSwapping ? `flipout` : '';
                const inClass = isSwapping ? `flipin` : '';
                return (
                  <div key={j} className="ffa-hero-bg-np-con1">
                    <div className="ffa-hero-bg-np-con2">
                      {isSwapping && (
                        <NonprofitCard {...commonCardProps} key={ids[swapIndex]} id={ids[swapIndex]} className={`ffa-hero-bg-np ${inClass}`} />
                      )}
                      <NonprofitCard {...commonCardProps} key={id} id={id} className={`ffa-hero-bg-np ${outClass}`} />
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }

  renderPreload() {
    const ids = this.getIds();
    const nextIndices = this.getNext6hi();
    const nextIds = nextIndices.map(index => ids[index]);
    return (<>
      {nextIds.map((id) => {
        return <NonprofitCard {...commonCardProps} key={id} id={id} preloadOnly />;
      })}
    </>);
  }

  render() {
    const {className, campaignId, editMode} = this.props;
    const ctaClass = 'btn special purple large ffa-hero-cta';
    const btnContent = <>Search Causes & Donate <Icon.Caret direction="right" /></>;

    return (
      <div className={`ffa-hero ${className}`}>
        {this.renderPreload()}
        {this.renderBg()}
        {editMode
          ? <button className={ctaClass} disabled>{btnContent}</button>
          : <Link href={paths.nonprofits({campaignId})} className={ctaClass}>{btnContent}</Link>
        }
      </div>
    );
  }

}

FfaHero.propTypes = {
  campaignId: PropTypes.string.isRequired,
  className: PropTypes.string,
  editMode: PropTypes.bool,
};

FfaHero.defaultProps = {
  className: '',
  editMode: false,
};

const stateToProps = (state) => ({
  ids: NonprofitsDuck.Slx.top100Ids(state),
});

const dispatchToProps = (dispatch) => ({
  load: () => dispatch(NonprofitsDuck.Ax.loadTop100()),
});

export default connect(stateToProps, dispatchToProps)(FfaHero);
